import { useAuth } from "../lib/AuthContext";
import { PointageTerrain } from "../components/PointageTerrain";
import { Clock } from "lucide-react";

export function Pointage() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-gray-50 pb-8">
      <div className="bg-white border-b px-4 py-3 flex items-center gap-3 sticky top-0 z-10">
        <Clock className="w-5 h-5 text-blue-600" />
        <h1 className="text-lg font-bold text-gray-900">Mon Pointage</h1>
      </div>
      <PointageTerrain user={user} />
    </div>
  );
}

// Re-export sub-components for route imports
export { RapportPointage } from './pointage/RapportPointage';
export { PointageManager } from './pointage/PointageManager';

export default Pointage;
